module.exports = __webpack_public_path__ + "media/world-small.8d8f8fc9.mp4";